var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    class: { "d-flex justify-center": !_vm.embed },
    style: `height:${_vm.height}px`,
    attrs: { id: _vm.rootElementId },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }